/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useState } from 'react'
import { useOnMount, useOnUnmount } from '@utils/reactExt'
import { observer } from 'mobx-react'
// css
import { BackBtn, Button } from '@styles/button.style'
import { isMobile } from 'react-device-detect'
import { LightListWrap, TitleWrap } from '@styles/base.style'
import { ArrowIco } from '@shared/Icon/ArrowIcon'
import authStore from '@store/authStore'
import Chat from '@views/Popup/Chat'
import NavBar from '@views/Navbar'
import useRootStore from '@store/useRootStore'
import { Badge } from 'antd'
import { ListView } from 'antd-mobile'
import _ from 'lodash'
import BottomLoading from '@components/BottomLoading'
import { NOTICE_REQUEST_TYPE } from '@v2/constants/common'
import { Notice as INotice } from '@v2/interface/common'
import { appScrollTo } from '@utils/utils'
import dayjs from 'dayjs'

const Notice: React.FC = (props) => {
  const { routerStore, globalStore, chattingStore, componentStore, logStore } = useRootStore()
  const { isChatEnabled } = chattingStore

  const [isLoading, setIsLoading] = useState(false)
  const [hasMore, setHasMore] = useState(false)
  const [notices, setNotices] = useState<INotice[]>(null)
  const [dataSource, setDataSource] = useState(new ListView.DataSource({
    rowHasChanged: (row1: INotice, row2: INotice) => row1 !== row2,
  }))

  useOnMount(() => {
    if (isMobile) {
      setTimeout(() => {
        appScrollTo(1)
      }, 0)
    }
    fetch(true).catch(console.error)
  })

  useOnUnmount(() => {
    try {
      if (componentStore.noticeBadgeEnabled) {
        componentStore.createAllNoticeReadHistory(null).catch(console.error)
        componentStore.setNoticeBadgeEnabled(false)
      }
    } catch (err) {
      console.error(err)
    }
  })

  const fetch = async (reset = false) => {
    try {
      setIsLoading(true)

      const params = {
        offset: reset ? 0 : _.size(notices),
        limit: 20,
        type: NOTICE_REQUEST_TYPE.NORMAL,
      }
      const result = await componentStore.fetchNotices(params)

      let newNotices = result.rows
      if (!reset) {
        newNotices = _.concat(notices, result.rows)
      }

      setNotices(newNotices)
      setDataSource(dataSource.cloneWithRows(newNotices))
      setHasMore(result.hasMore)
    } catch (err) {
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  }

  const renderRow = (row: INotice) => {
    return (
      <Button className="list-btn" onClick={() => {
        onClickNoticeDetail(row).catch(console.error)
      }}>
        {/* ***************** 고정글일 경우에 추가되는 이미지 입니다. ***************** */}
        {row.isTopNotice === 1 && (<span className="main-tag line"/>)}
        {/* ***************** 확인하지 않은 공지사항일 경우 ***************** */}
        {row.isVisibleBadge && (<Badge color="#DC2323" className="list-badge"/>)}
        <div className="list-info">
          <p className="tit">{row.title}</p>
          <p className="date">{dayjs(row.createdAt).format('YYYY.MM.DD')}</p>
        </div>
      </Button>
    )
  }

  const renderFooter = () => {
    let footer = <Fragment/>
    if (isLoading) {
      footer = <BottomLoading/>
    }
    return <div css={{ textAlign: 'center' }}>{footer}</div>
  }

  const endReachedHandler = async () => {
    if (isLoading) {
      return
    }

    if (hasMore) {
      await fetch()
    }
  }

  const openNoticeDetailPopup = (notice: INotice) => {
    componentStore.setNoticeDetail(notice)
    globalStore.setVisibleNoticeDetail(true)
  }

  const onClickNoticeDetail = async (notice: INotice) => {
    openNoticeDetailPopup(notice)

    if (!notice.isVisibleBadge) {
      return
    }

    try {
      await componentStore.createNoticeReadHistory({ id: notice.id })
      notice.isVisibleBadge = false
      notice.isVisibleMatchup = false
      componentStore.updateMatchupNotice(notice)
      onRefreshView()
    } catch (err) {
      console.error(err)
    }
  }

  const onRefreshView = () => {
    const newSource = new ListView.DataSource({
      rowHasChanged: (row1: INotice, row2: INotice) => row1 !== row2,
    })

    setDataSource(newSource.cloneWithRows({ ...notices }))
  }

  return (
    <Fragment>
      {isMobile && (
        <TitleWrap className="title-wrap white">
          <BackBtn onClick={() => {
            logStore.writeButtonLog({ pageId: 'd060', buttonId: '001' }).catch(console.error)
            routerStore.goBack()
          }}>
            <ArrowIco/>
          </BackBtn>
        </TitleWrap>
      )}
      <LightListWrap className={!isMobile && 'pc-bright-list-wrap'}>
        <ListView
          dataSource={dataSource}
          renderRow={renderRow}
          scrollRenderAheadDistance={500}
          renderFooter={renderFooter}
          onEndReached={endReachedHandler}
          onEndReachedThreshold={10}
          initialListSize={20}
          pageSize={20}
          useBodyScroll={isMobile}/>
      </LightListWrap>

      {isChatEnabled && !authStore.isSpecificClubMember && isMobile && <Chat key="notices:Chat"/>}
      {isMobile && <NavBar key="notices:NavBar"/>}
    </Fragment>
  )
}
export default observer(Notice)
